<!-- <div class="repair-diagram-bread-crum width-100p" *ngIf="locations?.length || illustrations?.length">
  <span *ngIf="isIllustrationSelected"></span>
  <span *ngIf="!isIllustrationSelected">{{selectedLocation?.displayName}}</span>
</div> -->
<div class="rd-component-diagram repair-diagram-content flex-row" *ngIf="locations.length || illustrations.length">
  <!-- Dialog Left Side Content -->
  <div class="repair-diagram-content-left">
    <!-- List of Component location & Illustration -->
    <div class="repair-diagram-list flex-column" *ngIf="!isIllustrationSelected">
      <div *ngFor="let location of locations" class="repair-diagram-list-item flex-start-center pointer"
        [ngClass]="{'active': location?.applicationId === selectedLocation?.applicationId}"
        (click)="getComponentLocationDetails(location)">
        <p class="mb-0 flex-column">
          <span class="font-600 capitalize">{{location?.displayName}}</span>
          <span>{{location?.description}}</span>
        </p>
      </div>

      <div *ngFor="let illustration of illustrations" class="repair-diagram-list-item flex-between-center pointer"
        [ngClass]="{'active': illustration?.applicationId === selectedIllustration?.applicationId}"
        (click)="getIllustrationDetails(illustration)">
        <p class="mb-0">
          <span class="font-600 capitalize">{{illustration?.displayName}}</span>
        </p>

        <i class="fal fa-chevron-right p-2"></i>
      </div>
    </div>

    <!-- List of Illustration Layers -->
    <div class="repair-diagram-list flex-column" *ngIf="isIllustrationSelected">
      <div class="repair-diagram-list-item flex-start-center pointer" (click)="handleIllustrationBack()">
        <i class="fal fa-chevron-left p-2"></i>

        <p class="mb-0 font-600 capitalize text-truncate" tooltipPosition="top"
          [pTooltip]="selectedIllustration?.displayName">
          {{selectedIllustration?.displayName}}
        </p>
      </div>

      <div *ngFor="let layer of selectedIllustration?.details"
        class="repair-diagram-list-item flex-start-center pointer"
        [ngClass]="{'active': selectedLayer?.elementRef === layer?.elementRef }"
        (click)="handleIllustrationLayerSelect(layer)">
        <p class="mb-0 font-600 capitalize">
          {{layer?.elementRef}} - {{layer?.name}}
        </p>
      </div>
    </div>
  </div>

  <!-- Dialog Right Side Content -->
  <div class="repair-diagram-content-right repair-diagram-wrapper" [hidden]="isLoading">
    <div class="image-viewer-counter-wrapper" *ngIf="!isSVG && documentUrls?.length > 1">
      <span class="font-18 font-gray-45 font-600">{{imageIndex + 1}} of {{documentUrls?.length}}</span>
    </div>

    <angular-image-viewer *ngIf="documentUrls?.length && !isSVG" [(index)]="imageIndex" [src]="documentUrls"
      [config]="config">
    </angular-image-viewer>

    <div class="svg-wrapper" [hidden]="!isSVG" [innerHTML]="svgDocument" #svgContainer>
    </div>
  </div>

  <div class="repair-diagram-content-right" [hidden]="!isLoading">
    <div class="flex-start-center font-14 p-2">
      <span class="pr-2">Loading...</span>
      <i class="fal fa-spinner rotate"></i>
    </div>
  </div>
</div>


  <div class="rd-component-diagram repair-diagram-content" *ngIf="!locations.length && !illustrations.length">
      <div class="flex-center-center component-service flex-column">
        <img src="../../../../../../assets/img/empty-icon-diagrams.svg" alt="" />
        <div class="pr-2 font-12 pt-2 font-gray-35" >There are no components & diagrams associated with this service.
      </div>
      </div>
  </div>

